import { defaultMetaMedicalRequest } from '../routesSetup';
import RequestIsForView from '../../lib/pages/RequestIsForView.vue';
import YourDetailsView from '../../lib/pages/YourDetailsView.vue';
import PatientDetailsView from '../../lib/pages/PatientDetailsView.vue';
import ProblemDetailsView from '../../lib/pages/ProblemDetailsView.vue';
import SummaryView from '../../lib/pages/SummaryView.vue';
import SubmittedSuccessfullyView from '../../lib/pages/SubmittedSuccessfullyView.vue';
import {
  formPatientDetailsProxy,
  formPatientProblemDetails,
  formReporterType,
  formYourDetails,
} from '@/data/forms';
import { RouteRecordRaw } from 'vue-router';
import { DefaultLayout } from '../../lib/layouts/layouts';
import MedicalWarningView from '../../lib/pages/MedicalWarningView.vue';

const medicalRequestChildren: RouteRecordRaw[] = [
  // not used
  {
    path: 'medical-warning',
    name: 'medical-warning-mr',
    component: MedicalWarningView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: "Check it's not an emergency",
      pageTitle: "Check it's not an emergency",
      nhsAppActions: {
        setBackAction: 'GO_BACK', // NB. Controls NHS App
        goToPage: 'GO_BACK',
        showBackNhsApp: true,
        showBackNhsAppWeb: false,
      },
    },
  },
  {
    path: 'request-is-for',
    name: 'request-is-for',
    component: RequestIsForView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formReporterType,
      layoutComponent: DefaultLayout,
      layoutPageTitle: null,
      nhsAppActions: {},
    },
  },
  {
    path: 'your-details',
    name: 'your-details',
    component: YourDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formYourDetails,
      nhsAppActions: {},
    },
  },
  {
    path: 'patient-details',
    name: 'patient-details',
    component: PatientDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formPatientDetailsProxy,
      nhsAppActions: {},
    },
  },
  // NB: NHS app can land here.
  {
    path: 'problem-details',
    name: 'problem-details',
    component: ProblemDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formPatientProblemDetails,
      requiresValidPatient: true,
      pageTitle: 'Request details',
      layoutPageTitle: 'Request details',
      nhsAppActions: {
        setBackAction: 'PP_GO_BACK', // NB. Controls Medicus Patient portal. Fire history -1
        goToPage: 'PP_GO_BACK',
        showBackNhsApp: true,
        showBackNhsAppWeb: true,
      },
    },
  },
  {
    path: 'summary',
    name: 'medical-summary',
    component: SummaryView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: 'Check your answers',
      requiresValidPatient: true,
      nhsAppActions: {
        setBackAction: 'PP_GO_BACK',
        goToPage: 'PP_GO_BACK',
        showBackNhsApp: true,
        showBackNhsAppWeb: true,
      },
    },
  },
  {
    path: 'submitted-successfully',
    name: 'medical-request-submitted-successfully',
    component: SubmittedSuccessfullyView,
    meta: {
      ...defaultMetaMedicalRequest,
      backButton: false,
      layoutPageTitle: null,
      pageTitle: 'Request submitted successfully',
      nhsAppActions: {
        showBackNhsApp: false,
        showBackNhsAppWeb: false,
      },
    },
  },
];

export default medicalRequestChildren;
